import { MAX_MOBILE_WIDTH } from '../../../../constants/generic';
import useResizeObserver from '../../../../hooks/useResizeObserver';
import { SMPFlex, SMPText, SMPContainer, useSizeContext } from '../../../index';

export interface ITextBlockProps {
  text?: string;
}

export const TextBlock = ({ text = 'No games to show' }: ITextBlockProps) => {
  const { setIsMobile } = useSizeContext();

  const measuredRef = useResizeObserver((fieldElement) => {
    setIsMobile(fieldElement.offsetWidth < MAX_MOBILE_WIDTH);
  });

  return (
    <SMPContainer variant='sportEntityContainer' ref={measuredRef}>
      <SMPFlex justify='center' align='center'>
        <SMPText size='4' variant='contrast'>
          {text}
        </SMPText>
      </SMPFlex>
    </SMPContainer>
  );
};
